module.exports = __webpack_public_path__ + "static/media/no-avatar.2d1ca381.svg";